/* istanbul ignore file */
import ReactGA from 'react-ga4';
import { isEmpty, isNil, get } from 'lodash';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';
import currentUserStorage from 'containers/services/security/current-user-storage';

export const EVENT_CATEGORIES = {
  SEARCH: 'Search',
  CLAIM: 'Claim',
};

export const init = () => {
  if (!isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID as string, {
      gaOptions: {
        userId: isNil(
          get(currentIntervenantStorage?.get(), 'preferred_username', null),
        )
          ? get(currentUserStorage?.get(), 'privileges.sagisName')
          : currentIntervenantStorage?.get()?.preferred_username,
      },
    });
    ReactGA.set({ debug: process.env.REACT_APP_GA_DEBUG === 'true' });
  }
};

export const pageView = () => {
  if (!isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
    });
  }
};

export const set = (field: string, value: string) => {
  if (!isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.set({ [field]: value });
  }
};

export const event = (
  category: string,
  action: string,
  label?: string,
  value?: number,
  nonInteraction?: boolean,
) => {
  if (!isEmpty(process.env.REACT_APP_GA_TRACKING_ID)) {
    ReactGA.event({
      category,
      action,
      label,
      value,
      nonInteraction,
    });
  }
};

const gtaTracker = { EVENT_CATEGORIES, init, pageView, set, event };

export default gtaTracker;
